import { NumberInput } from '@components/NumberInput';
import { Label } from '@components/styled/Label.styled';
import { NoteIcon } from '@src/assets';
import React from 'react';
import { Chip } from './Chip';
import * as styled from './styled/SquareFootageGroup.styled';
import { TitleGroup } from './TitleGroup';

export const SquareFootageGroup: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    return (
        <styled.SquareFootageGroup>
            <TitleGroup title="Size" Icon={NoteIcon} Chip={<Chip label="required" />} />

            <styled.Wrapper>
                <NumberInput disabled={disabled} name="squareFootage" />
                <Label>square feet</Label>
            </styled.Wrapper>
        </styled.SquareFootageGroup>
    );
};
